<template>
  <div class="health-consultation">
    <!-- Hero Section -->
    <section class="hero-section py-4">
      <div class="container">
        <div class="text-center mb-4">
          <h1 class="display-5 fw-bold text-primary">Health Consultation</h1>
          <p class="lead text-muted">Your Personal Health Management Platform</p>
        </div>

        <!-- Quick Actions -->
        <HealthQuickActions @tab-change="activeTab = $event" />
      </div>
    </section>

    <!-- Main Content -->
    <section class="py-4">
      <div class="container">
        <!-- Menstrual Tracking Tab -->
        <div v-if="activeTab === 'menstrual'">
          <MenstrualTracker />
        </div>

        <!-- Health Data Tab -->
        <div v-if="activeTab === 'health-data'">
          <HealthDataTracker />
        </div>

        <!-- AI Analysis Tab -->
        <div v-if="activeTab === 'ai-analysis'">
          <AIAnalysisReport />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HealthQuickActions from './component/health-consultation/HealthQuickActions.vue'
import MenstrualTracker from './component/health-consultation/MenstrualTracker.vue'
import HealthDataTracker from './component/health-consultation/HealthDataTracker.vue'
import AIAnalysisReport from './component/health-consultation/AIAnalysisReport.vue'

export default {
  name: 'HealthConsultation',
  components: {
    HealthQuickActions,
    MenstrualTracker,
    HealthDataTracker,
    AIAnalysisReport
  },
  data() {
    return {
      activeTab: 'menstrual'
    }
  },
  created() {
    // Set the active tab based on query parameter
    if (this.$route.query.tab) {
      this.activeTab = this.$route.query.tab
    }
  },
  watch: {
    // Watch for route changes
    '$route'(to, from) {
      if (to.query.tab) {
        this.activeTab = to.query.tab
      }
    }
  }
}
</script>

<style scoped>
.hero-section {
  background: linear-gradient(135deg, #fef7f7 0%, #f3e5f5 100%);
}

@media (max-width: 768px) {
  .hero-section {
    padding: 2rem 0 !important;
  }

  .display-5 {
    font-size: 1.8rem;
  }
}
</style>
